import RouteInfoObj from './RouteInfoObj'

export default RouteInfoObj